import request from '../../../helpers/request';

const getTenant = async (phone) => {
  const response = await request.get(`/HousingStock/client`, { phone });

  return response;
};

export default getTenant;
